export default {"src":"/_next/static/media/hero_2.fe0fa0e3.svg","height":547,"width":1576,"blurWidth":0,"blurHeight":0};